/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useRef, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { useLocation } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { getCategory } from "../../dish/core/_requests";
import CategoryModal from "./CategoryModal";
import EditCategory from "./EditCategory";
import SearchInput from "../../../component/core/Searchinput";
import Addbutton from "../../../component/core/Addbuttons";
interface Category {
  chefId: string | undefined;
  name: string;
  primaryId?: string;
  uuid: string;
  amount: number;
  type: {
    iconUrl: string;
    name: string;
  };
  enableDisableStatus: boolean;
  createdBy: string;
  updatedBy: string;
}

const ListCategory: React.FC = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [Category, setCategory] = useState<Category[]>([]);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  // useEffect to set the search term from URL (or local storage if needed)
  useEffect(() => {
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);
  const filterData = {
    search: dataSearch,
  };

  useEffect(() => {
    setLoading(true)
    getCategory(!chefId, search)
      .then((res) => {
                setCategory(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
    setLoading(false)
  }, [chefId, search]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clickApply = (e: React.FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
  };

  const [showModal, setShowModal] = useState(false);

  const handleModal = () => {
    setShowModal((prev) => !prev);
  };
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCategorytId, setEditCategorytId] = useState<string | null>(null);

  const handleEditModal = () => {
    setShowEditModal((prev) => !prev);
  };


  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Category.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(Category.length / itemsPerPage);

  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

                
  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
             <Addbutton
  title="Categories"
  count={Category.length}
  searchValue={search}
  onSearchChange={handleSearchChange}
  onSearchKeyUp={clickApply}
  buttonText="Add Category"
  buttonIcon="add_circle"
  onButtonClick={handleModal}
/>


              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={item.primaryId}>
                          <td>{indexOfFirstItem + i + 1}</td>
                          <td>
                            <p className="mb-0">{item.name}</p>
                          </td>
                          <td>
                            <div className="action-item">
                              <a
                                className="success cursorPointer"
                                onClick={() => { setEditCategorytId(item.uuid); handleEditModal() }}
                              >
                                <span className="material-symbols-outlined">
                                  edit
                                </span>

                              </a>
                              {/* <span
                                className="danger cursorPointer"
                                onClick={() => deleteCategory(item.primaryId)}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </span> */}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                           No Categories Added – Create One to Get Started!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>


              <Pagination
                data={Category}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>

            {/* Modal for Add Category */}
            <CategoryModal showModal={showModal} handleModal={handleModal} />
            {editCategorytId && <EditCategory show={showEditModal} onHide={handleEditModal} id={editCategorytId} />}
          </section>
        </div>
      </section>
    </>
  );
};

export default ListCategory;
